import { useEffect } from "react";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getLangAll } from "../../store/middleware";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";

import { Table } from "./styles";

function Languages() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { allLingos } = useSelector((state) => state.genericReducer);

  const renderButtonAdd = () => (
    <button className="buttonRight" onClick={() => navigate("/languages/new")}>
      <i className="fa fa-plus" aria-hidden="true" />
      Add New Language
    </button>
  );

  useEffect(() => {
    dispatch(getLangAll(true));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          typeIcon="custom"
          title={t("Languages")}
          rightButton={renderButtonAdd()}
          icon={<img src={Engrenagem} alt="Engrenagem" />}
          t={t}
        />
        <div className="content">
          <Table>
            <div className="bigBoxTableLanguage">
              <table>
                <tbody>
                  <tr>
                    <th>Flag</th>
                    <th>Language</th>
                    <th>Description</th>
                    <th>Status</th>
                  </tr>

                  {allLingos?.map(({ id, flag, language, description, active, customLang }) => {
                    const flagFormatted = !customLang ? flag.split("-")[0] : flag.split("-")[1];
                    return (
                      <tr key={id}>
                        <td>
                          <FlagIcon code={flagFormatted} />
                        </td>
                        <td>{language.name}</td>
                        <td>{description}</td>
                        <td>
                          <span style={{ color: active ? "#0ED572" : "#FF5666" }}>
                            {active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <button onClick={() => navigate(`/languages/${id}`)}>
                            View <i className="fa fa-angle-right" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Table>
        </div>
      </section>
    </div>
  );
}

export default Languages;
